import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy-dark">
      <div className="mx-auto max-w-6xl px-6 py-14 md:px-10">
        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div>
            <p className="text-lg font-bold text-white">WSafe AI Mobile</p>
            <p className="mt-2 text-sm text-slate-300">WorkSafeAgent LLC</p>
            <a
              href="mailto:info@wsafeai.com"
              data-testid="footer-email-link"
              className="mt-3 inline-block text-sm font-medium text-safety transition-colors duration-200 hover:text-white"
            >
              info@wsafeai.com
            </a>
          </div>

          <div className="flex flex-col gap-2" data-testid="footer-account-nav">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">
              Account
            </p>
            <a
              href="https://wsafeai.com/login"
              data-testid="footer-sign-in-link"
              className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
            >
              Sign in
            </a>
          </div>

          <nav className="flex flex-col gap-2" data-testid="footer-nav">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Legal</p>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
            >
              Terms of Service
            </Link>
          </nav>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-sm text-slate-400">
            &copy; {new Date().getFullYear()} WorkSafeAgent LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
